<template>
    <b-col md="6">
      <b-card title="Top 10 Produtos Mais Faturados no Período.">
        <app-echart-bar
            ref="refBarChartbar"
            :option-data="option"
        />
      </b-card>
    </b-col>
</template>

<script>
import { BCard, BCol, BRow } from 'bootstrap-vue';
import AppEchartBar from '@core/components/charts/echart/AppEchartBar.vue';
import { mapState } from 'vuex';

export default {
  components: {
    BCol,
    BRow,
    BCard,
    AppEchartBar,
  },
  data() {
    return {
      option: {
        xAxis: [
          {
            type: 'value',
          },
        ],
        yAxis: [
          {
            type: 'category',
            data: [],
            splitLine: { show: false },
            min: 0,
            max: '100px',
            axisLabel: {
              formatter: '{value}',
              fontSize: 12,
              fontFamily: 'Roboto, sans-serif',
              align: 'right',
            },

          },

        ],
        grid: {
          left: '100px',
          right: '30px',
          bottom: '30px',
        },
        series: [],
        chart: {
          type: 'bar',
        },
      },
    };
  },

  methods: {
    async dadosFiltrados10() {
      this.option.yAxis[0].data = await JSON.parse(JSON.stringify(this.labels));
      this.option.series = await JSON.parse(JSON.stringify(this.series));
    },
  },
  computed: {
    ...mapState({
      series: (state) => state.PTC_Dashboard.seriesTop10,
      labels: (state) => state.PTC_Dashboard.labelsTop10,
    }),
  },

};
</script>
